module.exports = __webpack_public_path__ + "static/img/PC-4.110801d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/PC-4.png
// module id = oigH
// module chunks = 0